import { Megaphone, ArrowUpRight } from "lucide-react";
import { AD_SLOTS } from "../data/content";

export function AdBanner({ index = 0, className = "" }) {
  const ad = AD_SLOTS[index % AD_SLOTS.length];
  return (
    <div
      data-testid={`ad-slot-${index}`}
      className={`relative overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-br ${ad.tone} p-6 ${className}`}
    >
      <span className="absolute right-3 top-3 rounded-full bg-black/30 px-2 py-0.5 text-[10px] uppercase tracking-wider text-slate-300">
        Sponsorisé
      </span>
      <Megaphone className="h-6 w-6 text-gold" strokeWidth={1.5} />
      <p className="mt-4 font-serif text-xl text-white">{ad.partner}</p>
      <p className="mt-1 text-sm text-slate-300">{ad.baseline}</p>
      <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-gold">
        {ad.cta} <ArrowUpRight className="h-4 w-4" />
      </span>
    </div>
  );
}
